import React from "react";
import styled from "@emotion/styled";
import { Flex, Text } from "styles/utility-components";

import Button from "../ui/button/Button";

type NoticeAnalysisActionBarProps = {
  selectedRows: string[];
  onSave: () => void;
  onClear: () => void;
};

export default function NoticeAnalysisActionBar({
  selectedRows,
  onSave,
  onClear,
}: NoticeAnalysisActionBarProps) {
  return (
    <Container>
      <Flex gap={16} alignItems="center">
        <Text color="sysTextWhite">{selectedRows.length} selected</Text>
        <ButtonContainer>
          <Button icon="bookmark" onClick={onSave}>
            Save
          </Button>
        </ButtonContainer>
      </Flex>
      <Flex gap={8} alignItems="center">
        <Button icon="xClose" onClick={onClear}>
          Deselect all
        </Button>
      </Flex>
    </Container>
  );
}

const Container = styled.div(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",

  height: 48,

  padding: 8,

  backgroundColor: theme.colors.sysPrimaryDefault,
  borderRadius: 4,
  boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.12)",
}));

const ButtonContainer = styled.div(({ theme }) => ({
  borderRadius: 4,
  border: `1px solid ${theme.colors.sysTextWhite}`,
}));
